import { RunnerProvider } from "gitpod-next-api/gitpod/v1/runner_configuration_pb";
import type { PlainRunner } from "@/queries/runner-queries";

/**
 * Checks if a runner is a managed runner served by Gitpod's RunnerManager.
 *
 * @param runner - The runner to check
 * @returns true if the runner is managed by Gitpod, false otherwise
 */
export function isManagedRunner(runner?: PlainRunner): boolean {
    if (!runner) {
        return false;
    }

    return runner.provider === RunnerProvider.MANAGED;
}
